import React from "react";
import ClockModeIcon from "../ClockModeIcon";

interface ClearConfigurableAreaButtonProps {
  onClear: () => void;
  disabled?: boolean;
  className?: string;
}

const ClearConfigurableAreaButton: React.FC<
  ClearConfigurableAreaButtonProps
> = ({ onClear, disabled = false, className = "" }) => {
  const handleClick = () => {
    if (window.confirm("确定要删除小组件吗？此操作不可撤销。")) {
      onClear();
    }
  };

  return (
    <>
      <div className="spacer"></div>
      <span className="settings-header">{"删除操作"}</span>
      <button
        type="button"
        onClick={handleClick}
        disabled={disabled}
        className={`action-button w-full hover:opacity-80 active:opacity-50 transition duration-200 ${className}`}
        aria-label="Clear configurable area"
      >
        <span className="text-red-500 flex items-center gap-[3px]">
          <ClockModeIcon type="trash" />
          {"删除小组件"}
        </span>
      </button>
    </>
  );
};

export default ClearConfigurableAreaButton;
